import api from "./utils";

// Existing endpoints (getResultsCount lives in generic_services.js as getAllResultsCount)
// The endpoint pages by 10 and ignores a limit param, so slice client-side; newest first
export const getRecentDocuments = (limit = 5) =>
  api.get("/web/crawl/results?sort_by=created_at&sort_direction=desc").then((r) => (r.data || []).slice(0, limit));

// Individual MISP dashboard endpoints — browser parallelizes up to 6 concurrent connections
export const getAttributeStats = () => api.get("/misp/stats/attributes").then((r) => r.data);
export const getCategoryStats  = () => api.get("/misp/stats/categories").then((r) => r.data);
export const getRecentEvents   = () => api.get("/misp/events/recent").then((r) => r.data);
export const getTimeline       = () => api.get("/misp/events/timeline").then((r) => r.data);
export const getTags           = () => api.get("/misp/tags").then((r) => r.data);
export const getGeoIps         = () => api.get("/misp/geo/ips").then((r) => r.data);
export const getFeeds          = () => api.get("/misp/feeds").then((r) => r.data);
export const getSightings      = () => api.get("/misp/sightings/recent").then((r) => r.data);
export const getThreatLevels    = () => api.get("/misp/stats/threat-levels").then((r) => r.data);
export const getActionableIocs  = () => api.get("/misp/stats/actionable-iocs").then((r) => r.data);
export const getThreatActors    = () => api.get("/misp/threat-actors").then((r) => r.data);
export const getMitreTechniques = () => api.get("/misp/mitre/techniques").then((r) => r.data);

// Per-user dashboard arrangement, stored server-side so it follows the user
// between browsers and machines. Both calls fail soft: the dashboard falls back
// to its built-in layout rather than breaking.
export const getDashboardLayout = () =>
  api.get("/api/user/dashboard-layout").then((r) => r.data?.layouts ?? null);

export const saveDashboardLayout = (layouts) =>
  api.put("/api/user/dashboard-layout", { layouts });
